import * as Yup from 'yup';

export const createFamilyFormSchema = Yup.object().shape({
  familyName: Yup.string()
    .required('Family Name is required'),
});
